/**
 * @file assertUnreachable.ts
 * @description A way to have Typescript check if a switch statement is exhaustive,
 * see: https://stackoverflow.com/a/39419171
 *
 * THIS IS USEFUL FOR ENUMS OR UNIONED STRING TYPES
 *
 * @example
 *
 * function getColorName(c: Color): string {
 *  switch(c) {
 *    case Color.Red:
 *      return 'red';
 *    case Color.Green:
 *      return 'green';
 *  }
 *  return assertUnreachable(c);
 * }
 *
 * You should see an error similar to:
 *
 * return assertUnreachable(c);
 *        ~~~~~~~~~~~~~~~~~~~~~
 *        Type "Color.Blue" is not assignable to type "never"
 *
 * The error message indicates the cases you forgot to include in your exhaustive switch!
 * If you left off multiple values, you'd see an error about e.g. Color.Blue | Color.Yellow.
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function assertUnreachable(_x: never): never {
  throw new Error("Didn't expect to get here");
}
